import { UIIcon } from '../config/icons';
import { MMessage, MCode, mMessagesGetLast } from '../lib/mdl/m-message';
import { UITableDefinition, UITable } from '../lib/ui/component/table';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { $time } from '../lib/y/time';
import { stQuery } from '../lib/st/statistics';
import { xavis_experiments } from '../lib/y/debug';

export class AdminLastMessagesScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const def = new UITableDefinition<MMessage>();
        def.addValue(e => $time(e.created_at), $fmt.DATE('MM-dd HH:mm'), { title: 'Time', width: -120 });
        def.addValue(m => m.channel, { title: 'Channel', width: -100 });
        if(xavis_experiments)
            def.addValue(m => m.code, { title: 'Code', width: -140 });
        def.addValue(e => e.display_to, { title: 'To', width: 100 });
        def.addValue(e => e.display_name, { title: 'Name', width: 150 });
        def.addValue(e => e.open_at ? 'open' : (e.deliveries?.[0]?.status ?? '-'), { title: 'State', width: -100 });

        def.addButtons([
            { icon: UIIcon.ARROW_UP_RIGHT_FROM_SQUARE, when: r => !!r.body_hash, tooltip: 'See message', link: p => '/docs/m/messages/body/' + p.body_hash }
        ], { width: -32 });

        def.preference_prefix = 'last_messages';

        const messages = await mMessagesGetLast();

        const source = new YArrayDataSource<MMessage>(messages);

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-wide', [
                new UITable(def, source),
            ]))
        ]);
    }
}

interface StatisticsRow {
    type: MCode;
    sent: number;
    delivered: number;
    open: number;
    bounced: number;
    clicked: number;
}

export class AdminMessageStatisticsScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const def = new UITableDefinition<StatisticsRow>();

        def.addValue(s => s.type, { title: 'Code', width: 80 });
        def.addValue(s => s.sent, $fmt.NUMBER, { title: 'Total sent', width: -120 });
        def.addValue(s => s.bounced / s.sent, $fmt.PERCENTAGE, { title: 'Bounce rate', width: -120 });
        def.addValue(s => s.open / s.delivered, $fmt.PERCENTAGE, { title: 'Open rate', width: -120 });
        def.addValue(s => s.clicked / s.delivered, $fmt.PERCENTAGE, { title: 'Click rate', width: -120 });

        def.preference_prefix = 'email_statistics';

        const stats = await stQuery({ scale: 'total', metric: 'messages', group: ['action_code', 'message_type'], counts: ['all'] });

        const rows: { [key: string]: StatisticsRow } = {}

        for(const s of stats.series) {
            const type = s.group.message_type as MCode;
            const code = s.group.action_code as string;
            let row = rows[type];
            if(!row) {
                row = { type: type, sent: 0, delivered: 0, open: 0, bounced: 0, clicked: 0 }
                rows[type] = row;
            }
            if(code == 'message_bounced')
                row.bounced = s.values[0][0];
            else if(code == 'message_sent')
                row.sent = s.values[0][0];
            else if(code == 'message_delivered')
                row.delivered = s.values[0][0];
            else if(code == 'message_open')
                row.open = s.values[0][0];
            else if(code == 'message_clicked')
                row.clicked = s.values[0][0];
        }

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-narrow', [
                new UITable(def, new YArrayDataSource(Object.values(rows).filter(r => r.sent > 0 && r.delivered > 0))),
            ])),
        ]);
    }
}
